import React from 'react';
import { TextBody, Link, Space } from '@ally/metronome-ui';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { oneTime, SERVER_TIMEZONE } from '../constants';
import { getTransferType } from '../utils';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
export var isImmediate = function (deliveryDate, withdrawalDate) {
    var compareDate = deliveryDate;
    if (withdrawalDate.valueOf() > deliveryDate.valueOf()) {
        compareDate = withdrawalDate;
    }
    return dayjs().tz(SERVER_TIMEZONE).isSameOrAfter(compareDate, 'day');
};
var DisclosureMessages = function (_a) {
    var transfer = _a.transfer, isWidget = _a.isWidget;
    var fromAccount = transfer.fromAccount, toAccount = transfer.toAccount, deliveryDate = transfer.deliveryDate, withdrawalDate = transfer.withdrawalDate, frequency = transfer.frequency;
    var isInvest = getTransferType(fromAccount, toAccount) === 'INVEST';
    var isInternal = getTransferType(fromAccount, toAccount) === 'INTERNAL';
    var isRecurring = !!(frequency && frequency !== oneTime);
    var immediate = isImmediate(deliveryDate, withdrawalDate);
    // Scenarios:
    // - Invest (immediate or recurring transfers)
    // - Baseline
    var Invest = function () {
        return (React.createElement(Space, { mt: "xs" },
            React.createElement(TextBody, { tag: "p", size: "sm", "data-testid": "disc-message" },
                "By choosing",
                ' ',
                isWidget ? (React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" }, "Submit")) : (React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" }, "Submit This Transfer")),
                ", you authorize this",
                ' ',
                isInvest && isRecurring && (React.createElement(TextBody, { tag: "span", size: "sm" },
                    "recurring",
                    ' ')),
                ' ',
                "transfer. If you want to cancel before the transfer processes, go to",
                ' ',
                React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" },
                    "Transfers Activity",
                    ' '),
                "or call us at",
                ' ',
                React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" },
                    isInvest || isRecurring ? (React.createElement(Link, { to: "tel:1-855-880-2559", text: "1-855-880-2559", withAllyTM: "tel:1-855-880-2559", "aria-label": "1, 8 5 5, 8 8 0, 2 5 5 9" })) : (React.createElement(Link, { to: "tel:1-877-247-2559", text: "1-877-247-2559", withAllyTM: "tel:1-877-247-2559", "aria-label": "1, 8 7 7, 2 4 7, 2 5 5 9" })),
                    ' '),
                ".")));
    };
    // Scenarios:
    // - Internal
    // - Self-Directed
    // - Invest (immediate and non-recurring)
    var InternalOrSelfDirect = function () {
        return (React.createElement(Space, { mt: "xs" },
            React.createElement(TextBody, { tag: "p", size: "sm", "data-testid": "disc-message" },
                "By choosing",
                ' ',
                isWidget ? (React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" }, "Submit")) : (React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" }, "Submit This Transfer")),
                ", you authorize this transfer. Once we start the transfer, you can't cancel it.")));
    };
    // TODO: This code will be used when Mangaed Portofolio flow is available.
    // Managed-Portfolio: Baseline, Recurring, Full, Full-immediate scenarios
    // const ManagedPortfolio = (): unknown => {
    //   const isFullAmount = true /* TODO: Add dynamic value for full amount */
    //   return (
    //     <Space mt="xs">
    //       {isFullAmount ? (
    //         <TextBody tag="p" size="sm" data-testid="disc-message">
    //           By choosing{' '}
    //           {isWidget ? (
    //             <TextBody tag="span" size="sm" weight="bold">
    //               Submit
    //             </TextBody>
    //           ) : (
    //             <TextBody tag="span" size="sm" weight="bold">
    //               Submit This Transfer
    //             </TextBody>
    //           )}
    //           , you authorize us to transfer your entire account balance.
    //           {isImmediate ? (
    //             <TextBody tag="p" size="sm">
    //               Allow up to 5 business days from the start date for us to
    //               liquidate your investments.
    //             </TextBody>
    //           ) : (
    //             <TextBody tag="p" size="sm">
    //               Allow up to 5 business days for us to review and complete your
    //               request.
    //             </TextBody>
    //           )}
    //           Once we start the transfer, you can’t cancel it. Your account will
    //           close once your transfer is complete.
    //         </TextBody>
    //       ) : (
    //         <TextBody tag="p" size="sm" data-testid="disc-message">
    //           By choosing{' '}
    //           {isWidget ? (
    //             <TextBody tag="span" size="sm" weight="bold">
    //               Submit
    //             </TextBody>
    //           ) : (
    //             <TextBody tag="span" size="sm" weight="bold">
    //               Submit This Transfer
    //             </TextBody>
    //           )}
    //           , you authorize this transfer. To generate your requested transfer
    //           amount, we may need up to 5 business days{' '}
    //           {isRecurring && (
    //             <TextBody tag="span" size="sm">
    //               from the start date
    //             </TextBody>
    //           )}{' '}
    //           to rebalance your portfolio. Once we start the transfer, you
    //           can&apos;t cancel it.
    //         </TextBody>
    //       )}
    //     </Space>
    //   )
    // }
    if ((isInvest || isInternal) && immediate && !isRecurring) {
        return React.createElement(InternalOrSelfDirect, null);
    }
    return React.createElement(Invest, null);
};
export default DisclosureMessages;
//# sourceMappingURL=DisclosureMessages.js.map